module.exports = __webpack_public_path__ + "components/trial/static/calendar-crossed-2d28e63a29895f0d07dd6156831a26fc.svg";